<div id="unit-prices-container">
  <div class="page-header">
    <app-toolbar-options icon="local_offer">
      <div class="d-flex flex-column" slot="start">
        <div class="page-title">Unit Prices</div>

      </div>
    </app-toolbar-options>
  </div>
  <div class="page-content" appanimatecss>


    <app-component-wrapper icon="add_task" title="View">
      <div class="d-flex flex-column" slot="start">
        <app-unit-prices-view></app-unit-prices-view>
      </div>
    </app-component-wrapper>


  </div>
</div>
